interface SectionHeadProps {
  title: string;
  subtitle?: string;
}

export default function SectionHead({ title, subtitle }: SectionHeadProps) {
  return (
    <div className="mb-6">
      <h2 className="font-display italic font-semibold text-3xl leading-tight text-forest">
        {title}
      </h2>
      <div className="mt-2 h-0.5 w-10 bg-cedar" />
      {subtitle && (
        <p className="mt-3 max-w-2xl text-sm text-bark/70">{subtitle}</p>
      )}
    </div>
  );
}
